import { Label } from '~/components/UI/shadcn/label'
import { RadioGroup, RadioGroupItem } from '~/components/UI/shadcn/radio-group'

import { useQuery } from '@tanstack/react-query'
import { getFilters } from '~/components/Content/Filters/data'
import { parseAsString, useQueryState } from 'nuqs'

type RadioProps = {
  data: {
    label?: string
    required: boolean
    note?: string
  }
  items?: {
    label?: string
    id?: string
  }
  disabled: true | false
  defaultValue?: string
  queryKey?: string
}

const RadioButtons = (props: RadioProps) => {
  const { disabled, data, items } = props
  const { id } = items || {}

  const { data: filterData, isLoading } = useQuery({
    queryKey: [id],
    queryFn: () => getFilters(id || ''),
    enabled: !!id // Only fetch if id exists
  })

  const firstItemId =
    filterData &&
    'items' in filterData &&
    Array.isArray(filterData.items) &&
    filterData.items.length > 0
      ? filterData.items[0].id
      : ''

  const [query, setQuery] = useQueryState<string>(
    props.queryKey || 'filters',
    parseAsString.withDefault(firstItemId)
  )
  const normalisedQuery = query || ''

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <div className='space-y-xs'>
      {data?.label && (
        <Label className='flex justify-between'>
          {data.label}{' '}
          {data?.required && <span className='text-blue-m'>*</span>}
        </Label>
      )}
      <RadioGroup
        defaultValue={normalisedQuery}
        disabled={disabled || false}
        onValueChange={value => setQuery(value)}
      >
        <div className='space-y-xs'>
          {filterData &&
            'items' in filterData &&
            Array.isArray(filterData.items) &&
            filterData.items.map(item => (
              <div key={item.id} className='space-x-xs group flex items-center'>
                <RadioGroupItem
                  value={item.id}
                  id={'radio-' + item.id}
                  aria-label={item.label}
                  className='group-hover:border-blue-m dark:hover:border-white'
                />
                <Label
                  htmlFor={'radio-' + item.id}
                  className='peer-disabled:text-grey-m cursor-pointer text-base font-normal group-hover:underline peer-disabled:cursor-not-allowed peer-disabled:no-underline'
                >
                  {item.label}
                </Label>
              </div>
            ))}
        </div>
      </RadioGroup>
      {data?.note && <p className='text-xs'>{data?.note}</p>}
      {/* {normalisedQuery && (
        <p className='text-grey-d text-sm'>
          Selected Filter: <span className='font-bold'>{normalisedQuery}</span>
        </p>
      )} */}
    </div>
  )
}

export default RadioButtons
